import { Offcanvas } from 'bootstrap'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Tippy from '@tippyjs/react'

import Icon from '../../../ui/Icon'
import Logo from '../../../ui/logo/Logo'
import { Button } from '../../../buttons/Button'
import SideNavContent from './sideNavContent/SideNavContent'

const MobileSideNav = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('nav')

  const goTo = (path: string) => {
    const sidebar = document.getElementById('sidenav')

    if (!sidebar) {
      navigate(path)
      return
    }

    const offcanvas = Offcanvas.getOrCreateInstance(sidebar)
    const onHidden = () => {
      sidebar.removeEventListener('hidden.bs.offcanvas', onHidden)
      navigate(path)
    }
    sidebar.addEventListener('hidden.bs.offcanvas', onHidden)
    offcanvas.hide()
  }

  return (
    <aside
      id="sidenav"
      className="offcanvas offcanvas-start ph-mobile-side"
      tabIndex={-1}
      aria-labelledby="sidebar-title"
    >
      <div className="offcanvas-header">
        <div id="sidebar-title">
          <Logo to="/dashboard" />
        </div>
        <Tippy
          content={t('side-bar.close')}
          placement="top"
          className="ph-tooltip"
        >
          <Button
            variant="ghost"
            className="ph-iconbtn mobile-side-close"
            icon={<Icon name="x" size={17} />}
            iconOnly
            label={t('side-bar.close')}
            data-bs-dismiss="offcanvas"
          />
        </Tippy>
      </div>
      <div className="offcanvas-body p-0">
        <SideNavContent onNavigate={goTo} />
      </div>
    </aside>
  )
}

export default MobileSideNav
